export default __webpack_public_path__ + "static/media/stats_inactive.30624ac2.svg";